// extracted by mini-css-extract-plugin
module.exports = {"empty-block":"styles_empty-block__1tIYu","empty-block__content":"styles_empty-block__content__qKTr-","empty-block__content-icon":"styles_empty-block__content-icon__l5iZz"};